import { ArrowDown, Star } from "lucide-react";
import { HERO_IMAGE, BRAND } from "../lib/constants";

export const Hero = ({ onBook }) => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden noise-overlay"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Detailed luxury car"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/90 via-transparent to-transparent" />
      </div>

      {/* Vertical "REVIVE" backdrop letter */}
      <div className="absolute right-[-30px] top-1/2 -translate-y-1/2 hidden lg:block pointer-events-none select-none">
        <div className="font-display font-bold text-[280px] leading-none text-white/[0.03] tracking-tighter">
          REVIVE
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-32 pt-32 w-full">
        <div className="flex items-center gap-3 mb-8 fade-up">
          <span className="red-bar" />
          <span className="font-mono-accent text-xs text-zinc-400">
            EST. SYDNEY · PREMIUM AUTO CARE
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display font-bold uppercase text-white text-6xl sm:text-7xl md:text-8xl lg:text-[140px] leading-[0.9] tracking-tighter max-w-5xl fade-up"
        >
          Reflect. <br />
          <span className="chrome-text">Restore.</span> <br />
          <span className="text-[#DC2626]">Revive.</span>
        </h1>

        <p
          data-testid="hero-subheadline"
          className="mt-8 max-w-xl text-zinc-300 text-base md:text-lg leading-relaxed fade-up"
        >
          Hand-finished detailing, three-stage paint correction, ceramic coatings and
          PPF — performed by obsessives who treat your car like our own.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 fade-up">
          <button
            data-testid="hero-book-btn"
            onClick={onBook}
            className="group inline-flex items-center justify-center gap-3 bg-[#DC2626] hover:bg-[#EF4444] text-white font-display font-bold uppercase tracking-wider text-sm px-8 py-5 transition-colors"
          >
            Book Your Detail
            <ArrowDown className="h-4 w-4 -rotate-45 group-hover:rotate-0 transition-transform" />
          </button>
          <button
            data-testid="hero-services-btn"
            onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center justify-center gap-3 bg-transparent border border-zinc-700 hover:border-zinc-400 text-white font-display font-bold uppercase tracking-wider text-sm px-8 py-5 transition-colors"
          >
            Explore Services
          </button>
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12 border-t border-white/5 pt-10 fade-up">
          {[
            { v: "500+", l: "Cars Detailed" },
            { v: "9H", l: "Ceramic Hardness" },
            { v: "5★", l: "Avg. Rating", icon: true },
            { v: "100%", l: "Satisfaction" },
          ].map((s) => (
            <div key={s.l} data-testid={`hero-stat-${s.l.toLowerCase().replace(/\s/g, "-")}`}>
              <div className="font-display font-bold text-3xl md:text-5xl text-white flex items-center gap-2">
                {s.v}
                {s.icon && <Star className="h-5 w-5 text-[#DC2626] fill-[#DC2626]" />}
              </div>
              <div className="font-mono-accent text-[10px] text-zinc-500 mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
